<template>
  <NuxtLayout name="default" class="theme-serv">
    <PageBlocks
      v-if="page"
      :content="page.blocks"
      :error="error"
      class="app-width-large"
    >
      <template #header>
        <div class="service__top-nav">
          <div class="app-width-default app-gutter">
            <UiButtonFlat type="left" :href="backlink.href">
              {{ backlink.label }}
            </UiButtonFlat>

            <h1>{{ service.name }}</h1>
          </div>
        </div>

        <UiBackgroundIso class="service__header app-width-default app-gutter" offset-x="-25vw">
          <div>
            <h2>{{ service.subtitle }}</h2>
            <BlocksTextsRichtext :content="service.description" />
          </div>
        </UiBackgroundIso>

        <template v-if="service.projects && service.projects.length">
          <div class="service__related">
            <UiTitleArrow :level="3" content="Réalisations" class="app-gutter" />
            <Related :items="service.projects" class="theme-prob" />
          </div>
        </template>
      </template>
    </PageBlocks>
  </NuxtLayout>
</template>

<script setup>
import { getServiceFromData } from '~/data/service';
definePageMeta({ layout: false });

const route = useRoute();
const { error, page, data } = await useFetchByPath(route.path);

/* here page specifics */
const { data: config } = await useAPIConfig();
const service = getServiceFromData(data.data);
const backlink = { href: '/' + (route.path).split('/').filter(v => v !== '')[0] };
backlink.label = config.value?.main_navigation.find(nav => nav.url === backlink.href)?.label || 'retour';
</script>

<style lang="stylus" scoped>
.service__top-nav {
  border-bottom 1px solid $cl-separator
}

.service__header {
  margin-top 50px
  margin-bottom 100px

  +size(L) {
    margin-top 100px
  }
}

:deep(.related) {
  background-color white
}
</style>
